<template>
    <div class="postbox mb--md" v-bind:style="{ 'background-image': 'url(' + data.image + ')' }">
        <img class="postbox__bg" v-bind:src="data.image"  />

        <div class="postbox__top">
            <ul class="postbox__tags">
                <li>{{ data.tag }}</li>
            </ul>

            <h4 class="postbox__title">{{ data.title }}</h4>
        </div>

        <div class="postbox__bottom">
            <router-link :to="{ name: 'news', params: { slug: data.slug }}" class="btn btn--primary btn--sm">
                More
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NewsItem",
        props: {
            'data': null,
        }
    }
</script>